import { render, staticRenderFns } from "./YouZanDetail.vue?vue&type=template&id=2fdfa994&"
import script from "./YouZanDetail.vue?vue&type=script&lang=js&"
export * from "./YouZanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports